import VueRouter, { RouteConfig } from 'vue-router'

const PrizeRecord = () => import('../views/PrizeRecord.vue')

export const prizeRecordRoute: RouteConfig = {
  path: '/prize-record',
  name: 'prize_record',
  component: PrizeRecord,
  meta: {
    title: '记录',
  },
}

export default [prizeRecordRoute]

export function navigateToPrizeRecord(router: VueRouter) {
  router.push({ name: prizeRecordRoute.name })
}
